import "./App.css";
import { HashRouter, useLocation } from "react-router-dom";
import RoutesIndex from "./routes";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { loaderStateTrue, loaderStateFalse } from "./actions/allActions";
import { withNamespaces } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import i18n from "./i18n";
import { ClipLoader } from "react-spinners";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

const App = (props) => {
    const { loaderStateFalse } = props;

    useEffect(() => {
        loaderStateFalse();
    }, [loaderStateFalse]);

    const { isLoading } = props;

    const options = [
        { value: "en", label: "English" },
        { value: "he", label: "Hebrew" },
    ];

    const [selectedLanguage, setSelectedLanguage] = useState(
        options.find((lang) => lang.value === i18n.language) || options[0]
    );

    const handleChange = (selectedOption) => {
        setSelectedLanguage(selectedOption);
        i18n.changeLanguage(selectedOption.value);
    };

    useEffect(() => {
        if (i18n.language === "he") {
            import("./utility/assets/css/hebrew.css")
                .then(() => console.log("Hebrew CSS loaded"))
                .catch((err) => console.error("Error loading Hebrew CSS", err));
        } else {
            import("./utility/assets/css/custom.css")
                .then(() => console.log("Custom CSS loaded"))
                .catch((err) => console.error("Error loading Custom CSS", err));
        }

        document.body.classList.toggle("hebrewClass", i18n.language === "he");

        const script = document.createElement("script");
        script.setAttribute("data-account", "68mFOCIT8L");
        script.setAttribute("src", "https://cdn.userway.org/widget.js");
        if (i18n.language) {
            script.setAttribute("data-language", i18n.language);
        }
        document.body.appendChild(script);

        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [i18n.language]);

    return (
        <div>
            {isLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 9999,
                        background: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                        }}
                    >
                        <ClipLoader color="#ffffff" size={50} />
                        <div>Loading your content...</div>
                    </div>
                </div>
            )}
            <ToastContainer />
            {/* <div className="language-dropdown">
                <Select
                    options={options}
                    value={selectedLanguage}
                    onChange={handleChange}
                />
            </div> */}
            <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <ScrollToTop />
                <RoutesIndex />
            </HashRouter>
        </div>
    );
};

const mapStateToProps = (globalState) => ({
    isLoading: globalState.mainReducerData.loaderState,
});

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })(
    withNamespaces()(App)
);
